import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { config } from '../config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CompetenciesService {

  constructor(private http: HttpClient) { }
  private deleteCompetencies = new Subject<any>();
  public newCompetency = new Subject<any>();

  public competencyDetails = new Subject<any>();
  competencyFile = this.competencyDetails.asObservable()

  newAddedCompetency = this.newCompetency.asObservable()

  newCompetencyAdded(data) {
    // return this.newCompetency.asObservable();
    this.newCompetency.next(data)
  }


  addCompetency(data: any): Observable<any> {
    console.log("Adding Competency", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "competencies", data).subscribe((res: any) => {
        console.log("NEW COMPETENCY RESPONSE", res)
        // this.newCompetency.next(res.data)
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }
  getCompetencies(id: any): Observable<any> {
    console.log("Getting Competency", id);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "competencies?_id=" + id).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  updateCompetency(data: any): Observable<any> {
    console.log("Updating competency", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "competencies", data).subscribe((res: any) => {
        console.log("Received Sending = ", res.data)
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }
  deleteCompetency(id) {
    return new Observable((observer) => {
      console.log("deleteCompetency", id);

      this.http.delete(config.baseApiUrl + "competencies?_id=" + id).subscribe((res: any) => {
        console.log("response of delete com", res);

        observer.next(res.data);
        this.deleteCompetencies.next(res.data)

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }

  deleteFile(competencieId, fileId) {
    return new Observable((observer) => {
      console.log("deleteFile", competencieId, fileId);

      this.http.delete(config.baseApiUrl + "competencies/file?competencieId=" + competencieId + "&fileId=" + fileId).subscribe((res: any) => {
        observer.next(res.data.clients);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }

  // Get Competency List form google sheet
  getCompetencyList(): Observable<any> {
    return new Observable<any>((observer) => {
      this.http.get(config.baseApiUrl + "competencies/list").subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  //Download trainig matrix sheet of all assigned competency to operative users
  downloadTrainingMatrix(): Observable<any> {
    return new Observable<any>((observer) => {
      this.http.get(config.baseApiUrl + "competencies/download-trainingmatrix").subscribe((res: any) => {
        observer.next(res);
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }


  deleteCompetenciesObservable(): Observable<any> {
    return this.deleteCompetencies.asObservable();
  }


  openCompetencyFile(data) {
    this.competencyDetails.next(data)
  }

  getUserDetails(instructorId, type): Observable<any> {
    console.log("Getting Instructors");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "instructors/digital-card-details?_id=" + instructorId + "&type=" + type).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }


}

